<template>
  <b-container class="pt-2">
    <b-row v-if="loading">
      <font-awesome-icon icon="spinner" size="lg" spin/>
    </b-row>
    <b-row v-if="!loading && !saving" class="text-left">
      <ol v-if="!loading && !saving">
        <li v-for="quickWin in quickWins" :key="quickWin.id" class="text-left">
          <font-awesome-icon icon="edit" :id="`edit-me-${quickWin.id}`" size="sm" @click="editingId=quickWin.id;newQuickWin=quickWin.quick_win;"/>
          <span v-html="quickWin.quick_win"/>
        </li>
      </ol>
    </b-row>
    <b-row class="pt-3 text-left">
      <b-col>
        <b-form-group 
          id="quickwingroup"
          breakpoint="md"
          label="Add Quick Win"
          label-for="quickwin"
          validated
        >
          <wysiwyg v-model="newQuickWin" id="quickwin"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="pt-3">
      <b-col>
        <b-button variant="success" @click="save()" :disabled="!newQuickWin">{{ editingId ? 'Update' : 'Add' }}</b-button>
      </b-col>
      <b-col v-if="editingId" >
        <vue-confirmation-button ref="deleteButton" :css="'btn btn-danger'" :messages="['Delete','Are you sure?','Deleted, reloading.....']" @confirmation-success="deleteItem();"/>
      </b-col>
      <b-col>
        <b-button variant="default" @click="newQuickWin=''; editingId=null;" v-if="newQuickWin || editingId">Cancel</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as API from "@/services/API";
import vueConfirmationButton from 'vue-confirmation-button';

export default {
    name: 'QuickWinsList',
    props: ['surveyRunId'],
    components: { vueConfirmationButton },
    data: function () {
        return {
            quickWins: [],
            newQuickWin: '',
            loading: true,
            saving: false,
            editingId: null
        }
    },
    created: function () {
      this.load();
    },
    methods: {
      save(){
        this.saving = true;
        return API.saveQuickWin(this.editingId, this.surveyRunId,this.newQuickWin).then(response => {
          this.newQuickWin = '';
          this.editingId = null;
          this.saving = false;
          this.load();
        });
      },
      load() {
        this.loading = true;
        return API.getQuickWins(this.surveyRunId).then(response => {
          this.quickWins = response;
          this.loading = false;
        });
      },
      deleteItem() {
        this.loading = true;
        const deleteButton = this.$refs.deleteButton;
        console.log(this);
        return API.deleteQuickWin(this.editingId, this.surveyRunId).then(response => {
          deleteButton.reset();
          this.newQuickWin = '';
          this.editingId = null;
          this.load();
        });
      }
    }
}
</script>
<style>
.editr--content {
  min-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/QuickWinsList.vue